import { reactive, ref } from 'vue';
import { type LngLatBoundsLike } from 'maplibre-gl';
import { defineStore } from 'pinia';

export const useJobSearchStore = defineStore(
    'jobStore',
    () => {
        const mapBounds = ref<LngLatBoundsLike>();

        const searchState = reactive<{
            tags: Record<string, string>;
            text: string;
        }>({
            tags: {},
            text: '',
        });

        function buildParams(
            withSearch: boolean = false,
            visibleFeatureIds?: number[]
        ): string {
            const params = new URLSearchParams();

            for (const key in searchState.tags) {
                if (key === 'location' && visibleFeatureIds) {
                    params.append('location', visibleFeatureIds.join(','));
                    continue;
                }

                params.append(key, searchState.tags[key] ?? '');
            }

            if (withSearch) {
                params.append('q', searchState.text ?? '');
            }

            return params.toString();
        }

        return {
            mapBounds,
            searchState,
            buildParams,
        };
    },
    {
        persist: {
            storage: window.sessionStorage,
            pick: ['mapBounds'],
            afterHydrate: (ctx) => {
                const queryParams = new URL(window.location.toString())
                    .searchParams;

                // overwrite searchState with query parameters
                if (queryParams.size > 0) {
                    ctx.store.searchState.tags = Object.fromEntries(
                        queryParams.entries()
                    );
                }
            },
        },
    }
);
